const customTabsContainers = document.querySelectorAll('.CustomTabs');

function closeOtherTabs() {
    document.querySelectorAll('.CustomTabs__item')?.forEach((item) => {
        item.classList.remove('active');
    });
}

function handleTabs(container) {
    container.querySelectorAll('.CustomTabs__item-heading')?.forEach((heading) => {
        heading.addEventListener('click', () => {
            // closeOtherTabs();
            heading.parentNode.classList.toggle('active');
        });
    });
}

customTabsContainers?.forEach((tabContainer) => {
    handleTabs(tabContainer);
});
